import React from 'react'
import axios from 'axios'
import {
  Breadcrumb,
  BreadcrumbItem,
  Button, Card,
  CardBody, CardFooter,
  CardHeader, Col,
  Form,
  FormGroup,
  Input, InputGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, PaginationItem, PaginationLink,
  Row,
  Table, Alert
} from "reactstrap";
import {Link} from "react-router-dom";
import {confirmAlert} from "react-confirm-alert";
import jwt from "jsonwebtoken";
import Pagination from "react-js-pagination";
import {USER_ROLE} from "../../constants";
import ImageUploading from 'react-images-uploading';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import fileDownload from "js-file-download";
import { getAllProvinces, getCommunesForProvince } from '../../data/vietnamAddressData';
import Select from 'react-select';

// Helper function to get CCCD image URL
const getCccdImageUrl = (imageName) => {
  const imagePath = typeof imageName === 'string' ? imageName.trim() : imageName;
  if (imagePath && imagePath.includes('uploads/cccd/')) {
    return `https://crm-api.tinphatexpress.vn/${imagePath}`;
  }
  // Use protected endpoint that requires authentication and domain whitelist
  return `/api/cccd/${imagePath}`;
};

class Customer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {
        total: 0,
        list: [],
        size: 20,
        from: 0,
        page: 1
      },
      modalToggle: false,
      modalEditToggle: false,
      modalToggleUpdateCustomer: false,
      modalCustomerInfo: {},
      modalCccdView: false,
      viewCccdImages: [],
      currUser: {},
      createCustomer: {
        companyName: "",
        name: "",
        address: "",
        phone: "",
        note: "",
        taxCode: "",
        customerType: "Khách lẻ",
        province: "",
        ward: "",
        streetAddress: "",
        cccdNumber: ""
      },
      editCustomer: {
        companyName: "",
        name: "",
        address: "",
        phone: "",
        note: "",
        taxCode: "",
        customerType: "",
        province: "",
        ward: "",
        streetAddress: "",
        cccdNumber: ""
      },
      isEdit: false,
      loading: false,
      search: '',
      customerType: "",
      images: [],
      searchType: "owner",
      disableDownloadButton: false,
      imagesEdit: [],
      cccdImages: [],
      cccdImagesEdit: [],
      provinces: [],
      communes: [],
      editCommunes: []
    }
    this.onDeleteCustomer = this.onDeleteCustomer.bind(this)
    this.openEditModal = this.openEditModal.bind(this)
    this.onCreateCustomer = this.onCreateCustomer.bind(this);
    this.onEditCustomer = this.onEditCustomer.bind(this)
    this.onEditCustomerChange = this.onEditCustomerChange.bind(this);
    this.toggleUpdateCustomer = this.toggleUpdateCustomer.bind(this);
    this.onCreateCustomerChange = this.onCreateCustomerChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.searchBy = this.searchBy.bind(this);
    this.onChange2 = this.onChange2.bind(this);
    this.setImages = this.setImages.bind(this);
  }

  async componentDidMount() {
    let token = localStorage.getItem('id_token')
    let currUser = jwt.decode(token)
    console.log(currUser)
    const provinces = getAllProvinces()
    await this.setState({
      currUser,
      provinces,
      createCustomer: {...this.state.createCustomer, owner: currUser.displayName}
    })
    await this.getAllCustomer()
  }

  async onCreateCustomer(e) {
    try {
      const {createCustomer, images, cccdImages} = this.state
      let imageLists = []
      let cccdImageLists = []

      if (!createCustomer.name || !createCustomer.phone) {
        toast.error('Vui lòng nhập tên và số điện thoại')
        return
      }

      if (!createCustomer.address) {
        toast.error('Vui lòng nhập địa chỉ Pickup')
        return
      }

      if (!createCustomer.cccdNumber) {
        toast.error('Vui lòng nhập Số CCCD')
        return
      }

      if (!cccdImages || cccdImages.length === 0) {
        toast.error('Vui lòng tải lên Hình ảnh CCCD')
        return
      }

      // Upload CCCD images
      if (cccdImages && cccdImages.length) {
        const formData = new FormData();
        cccdImages.forEach(i => {
          formData.append("photos", i.file);
        })
        const {data = []} = await axios({
          method: "post",
          url: "/upload-cccd",
          data: formData,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        });
        cccdImageLists = data
      }

      // Upload other images (if any)
      if (images && images.length) {
        const formData = new FormData();
        images.forEach(i => {
          formData.append("photos", i.file);
        })
        const {data = []} = await axios({
          method: "post",
          url: "/upload-customer",
          data: formData,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        });
        imageLists = data
      }

      // address field is already set by user input, no need to rebuild
      await axios.post('/create-customer', {
        ...createCustomer,
        images: imageLists.join(','),
        cccdImages: JSON.stringify(cccdImageLists)
      })

      this.setState((prevState) => ({
        modalToggle: !prevState.modalToggle,
        images: [],
        cccdImages: [],
        communes: []
      }));
      await this.getAllCustomer()
      e.preventDefault();
    } catch (err) {
      let message = err.response?.data?.message || 'Đã có lỗi xảy ra!'
      toast.error(message);
    }
  }

  async onEditCustomer(e) {
    try {
      const {images, imagesEdit, cccdImages, cccdImagesEdit, editCustomer} = this.state
      let imageLists = []
      let cccdImageLists = []

      if (!editCustomer.cccdNumber) {
        toast.error('Vui lòng nhập Số CCCD')
        return
      }

      // Check if there are any CCCD images (existing or new)
      const hasCccdImages = (cccdImages && cccdImages.length > 0) || (cccdImagesEdit && cccdImagesEdit.length > 0)
      if (!hasCccdImages) {
        toast.error('Vui lòng tải lên Hình ảnh CCCD')
        return
      }

      // Upload new CCCD images
      if (cccdImages && cccdImages.length) {
        const formData = new FormData();
        cccdImages.forEach(i => {
          formData.append("photos", i.file);
        })
        const {data = []} = await axios({
          method: "post",
          url: "/upload-cccd",
          data: formData,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        });
        cccdImageLists = data
      }

      // Combine with existing CCCD images
      if (cccdImagesEdit && cccdImagesEdit.length) {
        cccdImageLists = [...cccdImageLists, ...cccdImagesEdit]
      }

      // Upload new regular images
      if (images && images.length) {
        const formData = new FormData();
        images.forEach(i => {
          formData.append("photos", i.file);
        })
        const {data = []} = await axios({
          method: "post",
          url: "/upload-customer",
          data: formData,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        });
        imageLists = data
      }

      if (imagesEdit && imagesEdit.length) {
        imageLists = [...imageLists, ...imagesEdit]
      }

      // address field is already set by user input, no need to rebuild
      await axios.post(`/update-customer/${editCustomer.id}`, {
        ...editCustomer,
        images: imageLists.join(','),
        cccdImages: JSON.stringify(cccdImageLists)
      })

      this.setState((prevState) => ({
        modalEditToggle: !prevState.modalEditToggle,
        images: [],
        imagesEdit: [],
        cccdImages: [],
        cccdImagesEdit: [],
        editCommunes: []
      }));
      await this.getAllCustomer()
      e.preventDefault();
    } catch (err) {
      console.error(err)
      toast.error('Đã có lỗi xảy ra!')
    }
  }

  toggle() {
    this.setState((prevState, props) => ({modalToggle: !prevState.modalToggle}));
  }

  openEditModal(obj) {
    let imagesEdit = obj.images
    if (imagesEdit) {
      imagesEdit = imagesEdit.split(',')
    }

    let cccdImagesEdit = []
    if (obj.cccdImages) {
      try {
        cccdImagesEdit = JSON.parse(obj.cccdImages)
      } catch (e) {
        // If not JSON, try splitting by comma (backwards compatibility)
        cccdImagesEdit = obj.cccdImages.split(',').filter(img => img)
      }
    }

    // Load communes for selected province
    let editCommunes = []
    if (obj.province) {
      editCommunes = getCommunesForProvince(obj.province)
    }

    this.setState({
      editCustomer: obj,
      imagesEdit: imagesEdit,
      cccdImagesEdit: cccdImagesEdit,
      editCommunes: editCommunes
    })
    this.setState((prevState, props) => ({modalEditToggle: !prevState.modalEditToggle}));
  }

  toggleUpdateCustomer() {

  }

  onCreateCustomerChange(e) {
    const {name, value} = e.target;
    let createCustomerInfo = this.state.createCustomer
    console.log(name)

    createCustomerInfo[name] = value
    this.setState({createCustomer: createCustomerInfo})
  }

  onEditCustomerChange(e) {
    const {name, value} = e.target;
    let editCustomerInfo = this.state.editCustomer
    editCustomerInfo[name] = value
    this.setState({editCustomer: editCustomerInfo})
  }

  formatNumber(num) {
    return num
  }

  async onDeleteCustomer(id) {
    try {
      const self = this
      confirmAlert({
        title: "Delete Confirmation",
        message: "Are you sure to delete this Customer?",
        buttons: [
          {
            label: "Yes",
            onClick: async () => {
              const res = await axios.get(`/delete-customer/${id}`)
              console.log(res)
              await self.getAllCustomer()
            },
          },
          {
            label: "No",
            onClick: () => {
            },
          },
        ],
      });

    } catch (e) {
      console.error(e)
    }
  }

  onSelectChange = (e) => {
    const {value} = e
    this.setState({filterDateType: value})
  }

  searchBy(val) {
    this.setState({customerType: val})
  }
  searchByCode(val) {
    this.setState({searchType: val})
  }

  async getAllCustomer(params = {}) {
    try {
      this.setState({loading: true})
      const {search = '', searchType = 'owner', data} = this.state
      params.page = params.page  || data?.page
      let url = `/get-all-customer?page=${params.page || 1}&search=${search}&searchType=${searchType}`
      if (this.state.currUser.role === USER_ROLE.SALER || this.state.currUser.role === USER_ROLE.CONSULTANT || this.state.currUser.role === USER_ROLE.OPS) {
        url += `&owner=${this.state.currUser.displayName}`
      }
      if (this.state.customerType) {
        url += `&customerType=${this.state.customerType}`
      }
      const res = await axios.get(url)
      if (res && res.data) {
        this.setState({data: res.data})
      }
      this.setState({loading: false})
    } catch (e) {
      console.error(e)
      this.setState({loading: false})
    }
  }


  async exportData(params = {}) {
    await this.setState({disableDownloadButton: true})
    const {search = '', searchType = 'owner', data} = this.state
    params.page = params.page  || data?.page
    let url = `/download-customer?page=${params.page || 1}&limit=1000&search=${search}&searchType=${searchType}`
    if (this.state.currUser.role === USER_ROLE.SALER || this.state.currUser.role === USER_ROLE.CONSULTANT || this.state.currUser.role === USER_ROLE.OPS) {
      url += `&owner=${this.state.currUser.displayName}`
    }
    if (this.state.customerType) {
      url += `&customerType=${this.state.customerType}`
    }

    axios
      .get(url, {
        responseType: 'blob',
      })
      .then((res) => {
        fileDownload(
          res.data,
          `CUSTOMER_DATA_${new Date().toJSON().slice(0, 10)}.xlsx`,
        )
        this.setState({disableDownloadButton: false})
      })
      .catch(() => {
        this.setState({disableDownloadButton: false})
      })
    return
  }


  handlePageChange(pageNumber) {
    if (pageNumber === this.state.data.page) return
    this.getAllCustomer({page: pageNumber})
  }

  checkPermission() {
    try {
      const role = this.state.currUser.role
      if (role === USER_ROLE.ADMIN || role === USER_ROLE.CONSULTANT || role === USER_ROLE.OPS) {
        return true
      }
      return false
    } catch (e) {
    }
  }

  checkPermission2() {
    try {
      const role = this.state.currUser.role
      if (role === USER_ROLE.ADMIN || role === USER_ROLE.SALER || role === USER_ROLE.MANAGER || role === USER_ROLE.CUSTOMER || role === USER_ROLE.CONSULTANT || role === USER_ROLE.OPS) {
        return true
      }
      return false
    } catch (e) {
    }
  }

  handleInput = (e) => {
    const {value} = e.target
    this.setState({search: value})
  }
  onSearch = (e) => {
    this.getAllCustomer({search: this.state.search})
  }

  onChange2 = (imageList, addUpdateIndex) => {
    // data for submit
    this.setImages(imageList);
  };

  setImages(imageList) {
    this.setState({images: imageList})
  }

  onImageEditRemove = (index) => {
    let { imagesEdit } = this.state
    const filteredItems = imagesEdit.filter(item => item !== imagesEdit[index])
    this.setState({imagesEdit: filteredItems})
  }

  onCccdImageEditRemove = (index) => {
    let { cccdImagesEdit } = this.state
    const filteredItems = cccdImagesEdit.filter(item => item !== cccdImagesEdit[index])
    this.setState({cccdImagesEdit: filteredItems})
  }

  onProvinceChange = (selectedOption) => {
    const provinceName = selectedOption ? selectedOption.value : ''
    const communes = getCommunesForProvince(provinceName)
    this.setState({
      createCustomer: { ...this.state.createCustomer, province: provinceName, ward: '' },
      communes: communes
    })
  }

  onEditProvinceChange = (selectedOption) => {
    const provinceName = selectedOption ? selectedOption.value : ''
    const communes = getCommunesForProvince(provinceName)
    this.setState({
      editCustomer: { ...this.state.editCustomer, province: provinceName, ward: '' },
      editCommunes: communes
    })
  }

  onWardChange = (selectedOption) => {
    const wardName = selectedOption ? selectedOption.value : ''
    this.setState({
      createCustomer: { ...this.state.createCustomer, ward: wardName }
    })
  }

  onEditWardChange = (selectedOption) => {
    const wardName = selectedOption ? selectedOption.value : ''
    this.setState({
      editCustomer: { ...this.state.editCustomer, ward: wardName }
    })
  }

  onCccdImagesChange = (imageList) => {
    this.setState({cccdImages: imageList})
  }

  openCccdViewModal = (cccdImages) => {
    let images = []
    if (cccdImages) {
      try {
        images = JSON.parse(cccdImages)
      } catch (e) {
        // If not JSON, try splitting by comma (backwards compatibility)
        images = cccdImages.split(',').filter(img => img)
      }
    }
    this.setState({
      viewCccdImages: images,
      modalCccdView: true
    })
  }

  closeCccdViewModal = () => {
    this.setState({
      modalCccdView: false,
      viewCccdImages: []
    })
  }


  render() {
    const {data, editCustomer} = this.state
    const customerType = {
      DIV: "Khách lẻ",
      ODD: "Khách sĩ",
      FWD: "Khách FWD"
    }
    const maxNumber = 12;
    return (
      <div>
        <ToastContainer
          position='top-right'
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
        />
        <Breadcrumb>
          <BreadcrumbItem>TRANG </BreadcrumbItem>
          <BreadcrumbItem active> Customer </BreadcrumbItem>
        </Breadcrumb>
        <Row>
          <Col sm={6}>
            <div style={{marginBottom: '10px'}}>
              <Label style={{marginRight: '8px', width: '108px'}}>Phân loại: </Label>
              <select className="custom-select" style={{width: '200px', marginRight: '10px'}}
                      onChange={(e) => this.searchBy(e.target.value)}
              >
                <option value="">Tất cả</option>
                <option value="Khách lẻ">Khách lẻ</option>
                <option value="Khách sĩ">Khách sĩ</option>
                <option value="Khách FWD">Khách FWD</option>
              </select>
            </div>
            <div style={{marginBottom: '10px'}}>
              <Label style={{marginRight: '8px'}}>Tìm kiếm theo:</Label>
              <select className="custom-select" style={{width: '200px', marginRight: '10px'}}
                      onChange={(e) => this.searchByCode(e.target.value)}
              >
                <option value="owner">Tên người tạo</option>
                <option value="khCode">Mã KH</option>
                <option value="phone">Số điện thoại</option>
                <option value="khName">Tên khách hàng</option>
              </select>
            </div>
          </Col>
          <Col sm={6} className='ml-auto'>
            <form
              onSubmit={(e) => {
                e.preventDefault()
                this.onSearch()
              }}
            >
              <div className="d-flex">
                <InputGroup>
                  <Input
                    id="kgInput"
                    name="code"
                    value={this.state.search}
                    placeholder='Search'
                    onChange={this.handleInput}
                  />
                  <Button type="submit" className="btn-search ml-2">Search</Button>
                </InputGroup>
              </div>
            </form>
          </Col>
        </Row>
        <Card style={{marginTop: 20}}>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <span>Khách hàng</span>
            {
              this.checkPermission2({}, true) && (
                <div style={{display: 'flex', flexDirection: 'row', gap: '10px'}}>
                  {data.list.length > 0 && (
                    <Button
                      disabled={this.state.disableDownloadButton}
                      onClick={() => this.exportData()}
                    >
                      Tải về Excel
                    </Button>
                  )}
                  {this.checkPermission() && (
                    <Button type="button" className="butt ml-auto" onClick={this.toggle}>+ Tạo mới</Button>
                  )}
                </div>
              )
            }
          </CardHeader>
          <CardBody>
            {this.state.loading && (
              <div className="text-center">
                <span className="loader"></span>
              </div>
            )}
            <Table responsive bordered className="mb-0 table-hover" style={{fontSize: '13px'}}>
              <thead>
              <tr>
                <th style={{width: '40px'}}>#</th>
                <th style={{width: '90px'}}>Mã KH</th>
                <th style={{minWidth: '180px'}}>Thông tin khách hàng</th>
                <th style={{minWidth: '200px'}}>Địa chỉ</th>
                <th style={{width: '100px'}}>Phân loại</th>
                <th style={{width: '80px', textAlign: 'center'}}>CCCD</th>
                <th style={{width: '120px'}}>Người nhận</th>
                {this.checkPermission() && (
                  <th style={{width: '80px', textAlign: 'center'}}>Action</th>
                )}
              </tr>
              </thead>
              <tbody>
              {data.list &&
              data.list.map((obj, i) => (
                <tr key={i + 1}>
                  <td>{i + 1}</td>
                  <td>
                    <strong>KHTP{obj.id}</strong>
                  </td>
                  <td>
                    <div><strong>{obj.name}</strong></div>
                    <div style={{color: '#666', fontSize: '12px'}}>
                      📞 {obj.phone}
                    </div>
                    {obj.cccdNumber && (
                      <div style={{color: '#666', fontSize: '12px'}}>
                        🆔 {obj.cccdNumber}
                      </div>
                    )}
                    {obj.companyName && (
                      <div style={{color: '#666', fontSize: '12px'}}>
                        🏢 {obj.companyName}
                      </div>
                    )}
                    <div style={{color: '#999', fontSize: '11px', marginTop: '3px'}}>
                      👤 {obj.owner}
                    </div>
                  </td>
                  <td style={{fontSize: '12px'}}>
                    {obj.address && (
                      <div style={{marginBottom: '8px'}}>
                        <span style={{
                          display: 'inline-block',
                          padding: '2px 6px',
                          backgroundColor: '#007bff',
                          color: 'white',
                          borderRadius: '3px',
                          fontSize: '10px',
                          fontWeight: 'bold',
                          marginRight: '5px'
                        }}>PICKUP</span>
                        <span>{obj.address}</span>
                      </div>
                    )}
                    {(obj.streetAddress || obj.province || obj.ward) && (
                      <div>
                        <span style={{
                          display: 'inline-block',
                          padding: '2px 6px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          borderRadius: '3px',
                          fontSize: '10px',
                          fontWeight: 'bold',
                          marginRight: '5px'
                        }}>HÓA ĐƠN</span>
                        <span>
                          {[obj.streetAddress, obj.ward, obj.province].filter(Boolean).join(', ')}
                        </span>
                      </div>
                    )}
                    {obj.note && (
                      <div style={{color: '#999', fontSize: '11px', marginTop: '5px', fontStyle: 'italic'}}>
                        📝 {obj.note}
                      </div>
                    )}
                  </td>
                  <td>
                    <span className={`badge ${obj.customerType === 'Khách lẻ' ? 'badge-primary' : obj.customerType === 'Khách sĩ' ? 'badge-info' : 'badge-warning'}`}>
                      {obj.customerType}
                    </span>
                    {obj.customerType === "Khách FWD" && obj.taxCode && (
                      <div style={{fontSize: '11px', marginTop: '3px', color: '#666'}}>
                        MST: {obj.taxCode}
                      </div>
                    )}
                  </td>
                  <td className="text-center">
                    {obj.cccdImages && obj.cccdImages !== '[]' && obj.cccdImages !== '' ? (
                      (() => {
                        let images = []
                        try {
                          images = JSON.parse(obj.cccdImages)
                        } catch (e) {
                          images = obj.cccdImages.split(',').filter(img => img)
                        }
                        return (
                          <div style={{display: 'flex', gap: '3px', justifyContent: 'center', flexWrap: 'wrap'}}>
                            {images.slice(0, 2).map((image, idx) => (
                              <img
                                key={idx}
                                src={getCccdImageUrl(image)}
                                alt={`CCCD ${idx + 1}`}
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  objectFit: 'cover',
                                  borderRadius: '4px',
                                  cursor: 'pointer',
                                  border: '1px solid #ddd'
                                }}
                                onClick={() => this.openCccdViewModal(obj.cccdImages)}
                                title="Click để xem toàn bộ"
                              />
                            ))}
                            {images.length > 2 && (
                              <div
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  backgroundColor: '#f0f0f0',
                                  borderRadius: '4px',
                                  fontSize: '11px',
                                  fontWeight: 'bold',
                                  cursor: 'pointer',
                                  border: '1px solid #ddd'
                                }}
                                onClick={() => this.openCccdViewModal(obj.cccdImages)}
                                title="Click để xem toàn bộ"
                              >
                                +{images.length - 2}
                              </div>
                            )}
                          </div>
                        )
                      })()
                    ) : (
                      <span style={{color: '#999', fontSize: '11px'}}>Chưa có</span>
                    )}
                  </td>
                  <td style={{fontSize: '12px'}}>
                    {obj.CustomerReceivers && obj.CustomerReceivers.length > 0 ? (
                      <div>
                        <div style={{color: '#666', fontSize: '11px', marginBottom: '3px'}}>
                          ({obj.CustomerReceivers.length} người)
                        </div>
                        {obj.CustomerReceivers.slice(0, 2).map((receiver, index) => (
                          <div key={index} style={{fontSize: '11px', color: '#666'}}>
                            • {receiver.receiverName}
                          </div>
                        ))}
                        {obj.CustomerReceivers.length > 2 && (
                          <div style={{fontSize: '11px', color: '#999'}}>+ {obj.CustomerReceivers.length - 2} khác</div>
                        )}
                      </div>
                    ) : (
                      <div style={{color: '#999', fontSize: '11px'}}>Chưa có</div>
                    )}
                    <div style={{marginTop: '5px'}}>
                      <Link to={`/app/customer-receiver/${obj.id}`} className="text-blue" style={{fontSize: '11px'}}>
                        + Thêm
                      </Link>
                    </div>
                  </td>
                  {this.checkPermission2() && (
                    <td className="text-center">
                      <Button size="sm" style={{marginRight: '5px'}} type="button" color="info"
                              onClick={(e) => this.openEditModal(obj)}
                              title="Chỉnh sửa">
                        <i className="fa fa-edit"></i>
                      </Button>
                      {this.state.currUser.role !== USER_ROLE.CUSTOMER && (
                        <Button size="sm" type="button" color="danger"
                                onClick={(e) => this.onDeleteCustomer(obj.id)}
                                title="Xóa">
                          <i className="fa fa-trash"></i>
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
              ))}
              </tbody>
            </Table>
          </CardBody>

          <Pagination
            itemClass="page-item"
            linkClass="page-link"
            activePage={data.page}
            itemsCountPerPage={data.size}
            totalItemsCount={data.total}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange.bind(this)}
            hideFirstLastPages={true}
          />

        </Card>
        <Row>
          {/* Toggle Form Create Customer */}
          <Modal isOpen={this.state.modalToggle} toggle={this.toggle} size="xl">
            <Form>
              <ModalHeader toggle={this.toggle}>Thêm Khách hàng</ModalHeader>
              <ModalBody>
                <Row>
                  {/* Left Column */}
                  <Col md={6}>
                    <FormGroup>
                      <Label for="name">Tên khách hàng <span style={{color: 'red'}}>*</span></Label>
                      <Input type="text" name="name" id="name" placeholder="Tên Customer"
                             onChange={this.onCreateCustomerChange} required />
                      <Alert color="info" style={{marginTop: '8px', padding: '8px', fontSize: '13px'}}>
                        Vui lòng nhập đầy đủ họ tên theo Căn cước công dân (CCCD). Không để anh/chị.
                      </Alert>
                    </FormGroup>
                    <FormGroup>
                      <Label for="phone">Phone <span style={{color: 'red'}}>*</span></Label>
                      <Input name="phone" id="phone" placeholder="phone" onChange={this.onCreateCustomerChange}/>
                    </FormGroup>
                    <FormGroup>
                      <Label for="cccdNumber">Số CCCD <span style={{color: 'red'}}>*</span></Label>
                      <Input
                        type="text"
                        name="cccdNumber"
                        id="cccdNumber"
                        placeholder="Nhập số CCCD (9-12 số)"
                        maxLength="12"
                        onChange={this.onCreateCustomerChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="companyName">Company Name</Label>
                      <Input name="companyName" id="companyName" placeholder="companyName"
                             onChange={this.onCreateCustomerChange}/>
                    </FormGroup>
                    <FormGroup>
                      <Label for="customerType">Phân loại</Label>
                      <Input id="customerType" name="customerType" type="select" onChange={this.onCreateCustomerChange}>
                        {Object.values(customerType).map((object, i) => <option className="text-capitalize" value={object}
                                                                                key={i}>{object}</option>)}
                      </Input>
                    </FormGroup>
                    {this.state.createCustomer.customerType === "Khách FWD" && (
                      <FormGroup>
                        <Label for="taxCode">Mã số thuế <span style={{color: 'red'}}>*</span></Label>
                        <Input
                          type="text"
                          name="taxCode"
                          id="taxCode"
                          placeholder="Nhập mã số thuế"
                          onChange={this.onCreateCustomerChange}
                          required
                        />
                      </FormGroup>
                    )}
                    <FormGroup>
                      <Label for="note">Note</Label>
                      <Input name="note" id="note" placeholder="note" onChange={this.onCreateCustomerChange}/>
                    </FormGroup>
                  </Col>

                  {/* Right Column */}
                  <Col md={6}>
                    {/* Pickup Address Section */}
                    <div style={{
                      padding: '15px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px',
                      border: '1px solid #dee2e6',
                      marginBottom: '15px'
                    }}>
                      <h6 style={{
                        marginBottom: '12px',
                        color: '#495057',
                        fontWeight: '600',
                        borderBottom: '2px solid #007bff',
                        paddingBottom: '6px',
                        display: 'inline-block',
                        fontSize: '14px'
                      }}>📍 Địa chỉ Pickup</h6>
                      <FormGroup>
                        <Label for="address">Địa chỉ Pickup <span style={{color: 'red'}}>*</span></Label>
                        <Input type="text" name="address" id="address"
                               placeholder="Nhập địa chỉ pickup..."
                               onChange={this.onCreateCustomerChange}/>
                      </FormGroup>
                    </div>

                    {/* Invoice Address Section */}
                    <div style={{
                      padding: '15px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px',
                      border: '1px solid #dee2e6'
                    }}>
                      <h6 style={{
                        marginBottom: '12px',
                        color: '#495057',
                        fontWeight: '600',
                        borderBottom: '2px solid #28a745',
                        paddingBottom: '6px',
                        display: 'inline-block',
                        fontSize: '14px'
                      }}>🚚 Địa chỉ xuất hóa đơn</h6>
                      <FormGroup>
                        <Label for="streetAddress">Địa chỉ xuất hóa đơn</Label>
                        <Input type="text" name="streetAddress" id="streetAddress"
                               placeholder="Số nhà, tên đường..."
                               onChange={this.onCreateCustomerChange}/>
                      </FormGroup>
                      <FormGroup>
                        <Label for="province">Tỉnh/Thành phố</Label>
                        <Select
                          name="province"
                          id="province"
                          value={this.state.createCustomer.province ? { value: this.state.createCustomer.province, label: this.state.createCustomer.province } : null}
                          onChange={this.onProvinceChange}
                          options={this.state.provinces.map(province => ({ value: province.name, label: province.name }))}
                          placeholder="-- Chọn tỉnh/thành phố --"
                          isClearable
                          isSearchable
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="ward">Xã/Phường/Thị trấn</Label>
                        <Select
                          name="ward"
                          id="ward"
                          value={this.state.createCustomer.ward ? { value: this.state.createCustomer.ward, label: this.state.createCustomer.ward } : null}
                          onChange={this.onWardChange}
                          options={this.state.communes.map(commune => ({ value: commune.name, label: commune.name }))}
                          placeholder="-- Chọn xã/phường --"
                          isDisabled={!this.state.createCustomer.province}
                          isClearable
                          isSearchable
                        />
                      </FormGroup>
                    </div>
                  </Col>
                </Row>
                <FormGroup>
                  <Label for="cccdImages">Hình ảnh CCCD <span style={{color: 'red'}}>*</span></Label>
                  <ImageUploading
                    multiple
                    value={this.state.cccdImages}
                    onChange={this.onCccdImagesChange}
                    maxNumber={maxNumber}
                    dataURLKey="data_url"
                  >
                    {({
                        imageList,
                        onImageUpload,
                        onImageRemoveAll,
                        onImageUpdate,
                        onImageRemove,
                        isDragging,
                        dragProps,
                      }) => (
                      <div className="upload__image-wrapper">
                        <a className="btn btn-primary"
                          style={isDragging ? { color: 'red' } : undefined}
                          onClick={onImageUpload}
                          {...dragProps}
                        >
                          Chọn hình ảnh CCCD
                        </a>
                        &nbsp;&nbsp;&nbsp;
                        {
                          (this.state.cccdImages && this.state.cccdImages.length) ? (
                            <a onClick={onImageRemoveAll} className="btn btn-danger">Xóa tất cả</a>
                          ) : ''
                        }
                        <div className="image-list" style={{display: 'flex', flexWrap: 'wrap', gridGap: '15px'}}>
                          {this.state.cccdImages.map((image, index) => (
                            <div key={index} className="image-item" style={{marginTop: '10px'}}>
                              <img src={image['data_url']} alt="" width="100" />
                              <div className="image-item__btn-wrapper" style={{marginTop: '8px'}}>
                                <a onClick={() => onImageRemove(index)}>
                                  <img src="/close.png" alt="" width="10" />
                                </a>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </ImageUploading>
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={(e) => this.onCreateCustomer(e)}>Create</Button>{' '}
                <Button color="secondary" onClick={this.toggle}>Cancel</Button>
              </ModalFooter>
            </Form>
          </Modal>

          {/* Toggle Form Edit Customer */}
          <Modal isOpen={this.state.modalEditToggle} toggle={this.openEditModal} size="xl">
            <Form>
              <ModalHeader toggle={this.openEditModal}>Edit Khách hàng</ModalHeader>
              <ModalBody>
                <Row>
                  {/* Left Column */}
                  <Col md={6}>
                    <FormGroup>
                      <Label for="name">Tên khách hàng</Label>
                      <Input type="text" name="name" id="name" value={editCustomer.name} placeholder="Tên Customer"
                             onChange={this.onEditCustomerChange}/>
                      <Alert color="info" style={{marginTop: '8px', padding: '8px', fontSize: '13px'}}>
                        Vui lòng nhập đầy đủ họ tên theo Căn cước công dân (CCCD). Không để anh/chị.
                      </Alert>
                    </FormGroup>
                    <FormGroup>
                      <Label for="phone">Phone</Label>
                      <Input name="phone" id="phone" placeholder="phone" value={editCustomer.phone}
                             onChange={this.onEditCustomerChange}/>
                    </FormGroup>
                    <FormGroup>
                      <Label for="cccdNumber">Số CCCD <span style={{color: 'red'}}>*</span></Label>
                      <Input
                        type="text"
                        name="cccdNumber"
                        id="cccdNumber"
                        placeholder="Nhập số CCCD (9-12 số)"
                        maxLength="12"
                        value={editCustomer.cccdNumber || ''}
                        onChange={this.onEditCustomerChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="companyName">Company Name</Label>
                      <Input name="companyName" id="companyName" value={editCustomer.companyName} placeholder="companyName"
                             onChange={this.onEditCustomerChange}/>
                    </FormGroup>
                    <FormGroup>
                      <Label for="customerType">Hình thức thanh toán</Label>
                      <Input id="customerType" name="customerType" value={editCustomer.customerType} type="select"
                             onChange={this.onEditCustomerChange}>
                        {Object.values(customerType).map((object, i) => <option className="text-capitalize" value={object}
                                                                                key={i}>{object}</option>)}
                      </Input>
                    </FormGroup>
                    {editCustomer.customerType === "Khách FWD" && (
                      <FormGroup>
                        <Label for="taxCode">Mã số thuế <span style={{color: 'red'}}>*</span></Label>
                        <Input
                          type="text"
                          name="taxCode"
                          id="taxCode"
                          value={editCustomer.taxCode}
                          placeholder="Nhập mã số thuế"
                          onChange={this.onEditCustomerChange}
                          required
                        />
                      </FormGroup>
                    )}
                    <FormGroup>
                      <Label for="note">Note</Label>
                      <Input name="note" id="note" placeholder="note" value={editCustomer.note}
                             onChange={this.onEditCustomerChange}/>
                    </FormGroup>
                  </Col>

                  {/* Right Column */}
                  <Col md={6}>
                    {/* Pickup Address Section */}
                    <div style={{
                      padding: '15px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px',
                      border: '1px solid #dee2e6',
                      marginBottom: '15px'
                    }}>
                      <h6 style={{
                        marginBottom: '12px',
                        color: '#495057',
                        fontWeight: '600',
                        borderBottom: '2px solid #007bff',
                        paddingBottom: '6px',
                        display: 'inline-block',
                        fontSize: '14px'
                      }}>📍 Địa chỉ Pickup</h6>
                      <FormGroup>
                        <Label for="address">Địa chỉ Pickup</Label>
                        <Input type="text" name="address" id="address"
                               value={editCustomer.address || ''}
                               placeholder="Nhập địa chỉ pickup..."
                               onChange={this.onEditCustomerChange}/>
                      </FormGroup>
                    </div>

                    {/* Invoice Address Section */}
                    <div style={{
                      padding: '15px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px',
                      border: '1px solid #dee2e6'
                    }}>
                      <h6 style={{
                        marginBottom: '12px',
                        color: '#495057',
                        fontWeight: '600',
                        borderBottom: '2px solid #28a745',
                        paddingBottom: '6px',
                        display: 'inline-block',
                        fontSize: '14px'
                      }}>🚚 Địa chỉ xuất hóa đơn</h6>
                      <FormGroup>
                        <Label for="streetAddress">Địa chỉ xuất hóa đơn</Label>
                        <Input type="text" name="streetAddress" id="streetAddress"
                               value={editCustomer.streetAddress || ''}
                               placeholder="Số nhà, tên đường..."
                               onChange={this.onEditCustomerChange}/>
                      </FormGroup>
                      <FormGroup>
                        <Label for="province">Tỉnh/Thành phố</Label>
                        <Select
                          name="province"
                          id="province"
                          value={editCustomer.province ? { value: editCustomer.province, label: editCustomer.province } : null}
                          onChange={this.onEditProvinceChange}
                          options={this.state.provinces.map(province => ({ value: province.name, label: province.name }))}
                          placeholder="-- Chọn tỉnh/thành phố --"
                          isClearable
                          isSearchable
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="ward">Xã/Phường/Thị trấn</Label>
                        <Select
                          name="ward"
                          id="ward"
                          value={editCustomer.ward ? { value: editCustomer.ward, label: editCustomer.ward } : null}
                          onChange={this.onEditWardChange}
                          options={this.state.editCommunes.map(commune => ({ value: commune.name, label: commune.name }))}
                          placeholder="-- Chọn xã/phường --"
                          isDisabled={!editCustomer.province}
                          isClearable
                          isSearchable
                        />
                      </FormGroup>
                    </div>
                  </Col>
                </Row>
                <FormGroup>
                  <Label for="price">Hình ảnh CCCD <span style={{color: 'red'}}>*</span></Label>
                  {
                    (this.state.cccdImagesEdit && this.state.cccdImagesEdit.length) ? (
                      <div className="image-list" style={{display: 'flex', flexWrap: 'wrap', gridGap: '15px'}}>
                        {this.state.cccdImagesEdit.map((image, index) => (
                          <div key={index} className="image-item" style={{marginTop: '10px', position: 'relative'}}>
                            <img src={getCccdImageUrl(image)} alt="" width="100" />
                            <div className="image-item__btn-wrapper" style={{marginTop: '8px', position: 'absolute', right: 0,
                              top: 0}}>
                              <a onClick={() => this.onCccdImageEditRemove(index)}>
                                <img src="/close.png" alt="" width="10" />
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : ''
                  }

                  <ImageUploading
                    multiple
                    value={this.state.cccdImages}
                    onChange={this.onCccdImagesChange}
                    maxNumber={maxNumber}
                    dataURLKey="data_url"
                  >
                    {({
                        imageList,
                        onImageUpload,
                        onImageRemoveAll,
                        onImageUpdate,
                        onImageRemove,
                        isDragging,
                        dragProps,
                      }) => (
                      <div className="upload__image-wrapper"
                           style={{marginTop: '30px'}}>
                        <a className="btn btn-primary"
                          style={isDragging ? { color: 'red' } : undefined}
                          onClick={onImageUpload}
                          {...dragProps}
                        >
                          Chọn thêm hình ảnh CCCD
                        </a>
                        &nbsp;&nbsp;&nbsp;
                        {
                          (this.state.cccdImages && this.state.cccdImages.length) ? (
                            <a onClick={onImageRemoveAll} className="btn btn-danger">Xóa tất cả</a>
                          ) : ''
                        }
                        <div className="image-list" style={{display: 'flex', flexWrap: 'wrap', gridGap: '15px'}}>
                          {this.state.cccdImages.map((image, index) => (
                            <div key={index} className="image-item" style={{marginTop: '10px'}}>
                              <img src={image['data_url']} alt="" width="100" />
                              <div className="image-item__btn-wrapper" style={{marginTop: '8px'}}>
                                <a onClick={() => onImageRemove(index)}>
                                  <img src="/close.png" alt="" width="10" />
                                </a>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </ImageUploading>
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={(e) => this.onEditCustomer(e)}>Update</Button>{' '}
                <Button color="secondary" onClick={this.openEditModal}>Cancel</Button>
              </ModalFooter>
            </Form>
          </Modal>

          {/* Modal View CCCD Images */}
          <Modal isOpen={this.state.modalCccdView} toggle={this.closeCccdViewModal} size="lg">
            <ModalHeader toggle={this.closeCccdViewModal}>Hình ảnh CCCD</ModalHeader>
            <ModalBody>
              {this.state.viewCccdImages && this.state.viewCccdImages.length > 0 ? (
                <div className="image-list" style={{display: 'flex', flexWrap: 'wrap', gridGap: '15px', justifyContent: 'center'}}>
                  {this.state.viewCccdImages.map((image, index) => (
                    <div key={index} className="image-item" style={{marginTop: '10px', textAlign: 'center'}}>
                      <img src={getCccdImageUrl(image)} alt={`CCCD ${index + 1}`} style={{maxWidth: '100%', height: 'auto', border: '1px solid #ddd', borderRadius: '4px', padding: '5px'}} />
                      <p style={{marginTop: '8px', fontSize: '14px'}}>Ảnh {index + 1}</p>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-center">Không có hình ảnh CCCD</p>
              )}
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.closeCccdViewModal}>Đóng</Button>
            </ModalFooter>
          </Modal>

        </Row>
      </div>
    )
  }
}

export default Customer
